import React from 'react';
import PropTypes from 'prop-types';

export default function Copy(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={props.width} height={props.width} fill={props.color} >
      <path d="M149.3 128V64c0-5.7 2.2-11.1 6.2-15.1s9.4-6.2 15.1-6.2h256c5.7 0 11.1 2.2 15.1 6.2s6.2 9.4 6.2 15.1V362.7c0 5.7-2.2 11.1-6.2 15.1s-9.4 6.2-15.1 6.2h-64v64c0 11.8-9.6 21.3-21.5 21.3H85.5c-2.8 0-5.6-.5-8.2-1.6s-5-2.6-7-4.6s-3.6-4.3-4.7-6.9s-1.6-5.4-1.6-8.2l.1-298.7c0-11.8 9.6-21.3 21.5-21.3h63.8zm-42.6 42.7l-.1 256H320v-256H106.7zM192 128H362.7V341.3h42.7V85.3H192V128z"/>
    </svg>
  );
}

Copy.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Copy.defaultProps = {
  color: '#ffffff',
  width: 20,
};
